import { Button, Flex, Tooltip } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { CommentInput } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/CommentInput';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	comment: string;
	commentError: string;
	isLoading: boolean;
	disabled?: boolean;
	onCommentChange: (next: string) => void;
	onCancel: () => void;
	onConfirm: () => void;
}

export const RejectionConfirmation = ({
	comment,
	commentError,
	isLoading,
	disabled,
	onCommentChange,
	onCancel,
	onConfirm,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" gap="0.75rem">
			<CommentInput
				comment={comment}
				onCommentChange={onCommentChange}
				commentError={commentError}
				addCommentText={tMipManage('kyc.review.add_comment')}
				placeholder="Add a comment..."
				disabled={disabled}
			/>
			<Flex gap="0.5rem">
				<Button variant="default" fullWidth onClick={onCancel}>
					{tMipManage('kyc.review.cancel')}
				</Button>
				<Tooltip label={tMipManage('kyc.review.tooltip.decline')} position="bottom">
					<Button
						data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_KYC_REVIEW_REJECT_CONFIRM_BUTTON}
						fullWidth
						loading={isLoading}
						onClick={onConfirm}
						disabled={disabled}
					>
						{tMipManage('kyc.review.confirm')}
					</Button>
				</Tooltip>
			</Flex>
		</Flex>
	);
};
